import React from 'react';
import { TagName } from '../../../../utils/tagName.const';
import Text, { TextType } from '../../Text/Text';
import { PriceItemDataHooks } from '../PaymentSummary/PriceItem/dataHooks';
import { classes } from './Discount.st.css';

export const DiscountRuleName = ({ name }: { name: string | undefined }) =>
  name ? (
    <Text
      type={TextType.Secondary}
      tagName={TagName.Paragraph}
      className={classes.discountRuleName}
      data-hook={PriceItemDataHooks.DiscountRuleName}
    >
      {name}
    </Text>
  ) : null;

export const PriceBeforeDiscount = ({
  price,
  type,
}: {
  price: string | undefined;
  type: TextType;
}) =>
  price ? (
    <Text
      type={type}
      tagName={TagName.Span}
      className={classes.priceBeforeDiscount}
      data-hook={PriceItemDataHooks.PriceBeforeDiscount}
    >
      {price}
    </Text>
  ) : null;
